"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Tooltip_1 = __importDefault(require("@web/common/Tooltip"));
const AllPricesView_1 = __importDefault(require("@react/web/Common/Price/AllPricesView"));
const OfferInquiryButtonView_1 = __importDefault(require("@react/web/SubscriptionOfferDetail/views/OfferInquiryButtonView"));
const FlexibleBox = ({ flexibleOffer, services, }) => {
    (0, react_1.useEffect)(() => {
        const offerDetail = document.getElementById('subscription-offer-detail');
        if (offerDetail) {
            const tooltip = offerDetail.querySelector('.tooltip');
            if (tooltip) {
                (() => new Tooltip_1.default(tooltip))();
            }
        }
    }, []);
    return react_1.default.createElement("div", { className: "subscription-offer-box" },
        react_1.default.createElement("ul", { className: "services-list", dangerouslySetInnerHTML: { __html: services } }),
        react_1.default.createElement("div", { className: "subscription-prices-container" },
            react_1.default.createElement("div", { className: "price-container installment" },
                react_1.default.createElement("div", { className: "price-title" }, "M\u011Bs\u00ED\u010Dn\u00ED pron\u00E1jem"),
                react_1.default.createElement("div", { className: "prices-container", itemProp: "offers", itemScope: true, itemType: "https://schema.org/Offer" },
                    react_1.default.createElement("meta", { itemProp: "price", content: Math.round(flexibleOffer.monthlyPrice.withoutVat).toString() }),
                    react_1.default.createElement("meta", { itemProp: "priceCurrency", content: "CZK" }),
                    react_1.default.createElement("link", { itemProp: "availability", href: "https://schema.org/InStock" }),
                    (0, AllPricesView_1.default)(flexibleOffer.monthlyPrice))),
            react_1.default.createElement("div", { className: "price-container starting-fee" },
                react_1.default.createElement("div", { className: "price-title" }, "Startovac\u00ED poplatek"),
                react_1.default.createElement("div", { className: "prices-container" }, (0, AllPricesView_1.default)(flexibleOffer.startingFee)),
                react_1.default.createElement("span", { className: "tooltip gtm-dk-starting-fee-tooltip", "data-title": "Startovac\u00ED poplatek je jednor\u00E1zov\u00E1 nevratn\u00E1 platba. D\u00EDky n\u011Bmu m\u016F\u017Eete auto kdykoli bezplatn\u011B vr\u00E1tit a nemus\u00EDte se dlouhodob\u011B v\u00E1zat.\n                    \nStartovac\u00ED poplatek nemus\u00EDte platit najednou. Rozlo\u017E\u00EDme v\u00E1m ho podle pot\u0159eby do n\u011Bkolika m\u011Bs\u00ED\u010Dn\u00EDch spl\u00E1tek." }))),
        react_1.default.createElement(OfferInquiryButtonView_1.default, { offer: flexibleOffer, gtmInquiryTypeEnum: "flexible" }));
};
exports.default = FlexibleBox;
